module.exports = __webpack_public_path__ + "static/media/background.5fd2d0f9.png";